import { HttpParams } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Mandant } from '../../../../../projects/kiene-core/src/lib/components/mandanten/classes/mandant';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { LocalStorageService } from '../../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { KieneTableService } from '../../../components/kiene-table/kiene-table.service';
import { Material } from '../../material/material';
import { Supplier } from '../../supplier/supplier';
import { SupplierMaterial } from '../supplier-material';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { KieneUtils } from '../../../../../projects/kiene-core/src/lib/utils/KieneUtils';

@Component({
    selector: 'kiene-add-supplier-material',
    templateUrl: './add-supplier-material.component.html',
    styleUrls: ['./add-supplier-material.component.scss'],
})
export class AddSupplierMaterialComponent implements OnInit {
    material: Material;
    supplierMaterial: SupplierMaterial;
    create = false;

    preisCtrl = new UntypedFormControl();
    //skontoCtrl = new FormControl();
    //zahlungszielCtrl = new FormControl();
    rabattCtrl = new UntypedFormControl();
    standardCtrl = new UntypedFormControl();
    skontoCtrl = new UntypedFormControl();
    zahlungszielCtrl = new UntypedFormControl();

    availableMandanten: Mandant[] = [];

    mandantCtrl: UntypedFormControl[] = [];
    selectedMandantenIds: number[] = [];
    isStandardLieferant = false;

    constructor(
        public dialogRef: MatDialogRef<AddSupplierMaterialComponent>,
        @Inject(MAT_DIALOG_DATA) private data,
        private api: KieneTableService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private notification: MessageService,
        private localStorageService: LocalStorageService,
    ) {
        this.material = data.material;
        this.supplierMaterial = data.supplierMaterial;
        if (data.create) {
            this.create = data.create;
        }
    }

    ngOnInit() {
        this.loadAvailableMandanten(this.supplierMaterial);

        if (this.supplierMaterial) {
            this.isStandardLieferant = KieneUtils.isApiOne(this.supplierMaterial.standard_lieferant);
            this.preisCtrl.setValue(this.supplierMaterial.einzelpreis);
            this.rabattCtrl.setValue(this.supplierMaterial.rabatt);
            this.standardCtrl.setValue(KieneUtils.isApiOne(this.supplierMaterial.standard_lieferant));
            this.skontoCtrl.setValue(this.supplierMaterial.skonto);
            this.zahlungszielCtrl.setValue(this.supplierMaterial.zahlungsziel);
        } else {
        }
    }

    loadAvailableMandanten(sm: SupplierMaterial) {
        if (this.localStorageService.currentUserHasPermission(1095)) {
            if (sm) {
                let params = new HttpParams();
                params = params.append('artikel_id', sm.artikel_id.toString());
                params = params.append('lieferant_id', sm.lieferant_id.toString());
                this.api.get(this.apiBaseUrl + 'artikel_lieferant/read_mandanten.php', params).subscribe(
                    response => {
                        this.availableMandanten = response.records;
                        for (let m of this.availableMandanten) {
                            this.mandantCtrl[m.mandant_id] = new UntypedFormControl(true);
                        }
                        this.updateSelectedMandanten();
                    },
                    error => {
                        this.notification.errorMessage('Fehler beim Laden der Mandanten', error);
                    },
                );
            }
        }
    }

    updateSelectedMandanten() {
        this.selectedMandantenIds = [];
        for (let m of this.availableMandanten) {
            const mandantId = Number(m.mandant_id);
            if (this.mandantCtrl[m.mandant_id].value) {
                this.selectedMandantenIds.push(mandantId);
            }
        }
    }

    setSupplier(supplier: Supplier) {
        if (!this.supplierMaterial) {
            this.supplierMaterial = new SupplierMaterial();
        }
        this.supplierMaterial.lieferant_id = supplier.lieferant_id;
        this.supplierMaterial.artikel_id = this.material.artikel_id;
        this.supplierMaterial.lieferant = supplier.bezeichnung;

        this.loadAvailableMandanten(this.supplierMaterial);
    }

    close() {
        this.dialogRef.close(null);
    }

    save() {
        if (this.create && !this.supplierMaterial) {
            this.supplierMaterial = new SupplierMaterial();
        }

        if (this.localStorageService.currentUserHasPermission(1095)) {
            this.supplierMaterial.mandanten_ids = this.selectedMandantenIds.map(id => Number(id));
        }
        console.log('ZahlungszielCtrl Value:', this.zahlungszielCtrl.value);

        this.supplierMaterial.artikel_id = this.material.artikel_id;
        this.supplierMaterial.einzelpreis = this.preisCtrl.value;
        this.supplierMaterial.skonto = +this.skontoCtrl.value;
        this.supplierMaterial.zahlungsziel = +this.zahlungszielCtrl.value;
        this.supplierMaterial.rabatt = this.rabattCtrl.value;
        this.supplierMaterial.standard_lieferant = this.standardCtrl.value ? 1 : 0;
        console.log('SupplierMaterial to send:', this.supplierMaterial);
        this.dialogRef.close(this.supplierMaterial);
    }
}
